/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NetworkModule
 */

const moduleName = 'network';
const componentName = 'network-and-subnet';
const prefix = `${moduleName}.${componentName}`;

export const networkSelectLabel = `${prefix}.networkSelectLabel`;
export const networkSelectPlaceholder = `${prefix}.networkSelectPlaceholder`;
export const subnetSelectLabel = `${prefix}.subnetSelectLabel`;
export const subnetDropdownPlaceholder = `${prefix}.subnetDropdownPlaceholder`;
export const subnetInputPlaceholder = `${prefix}.subnetInputPlaceholder`;

export const ENGLISH = {
    [networkSelectLabel]: 'Network',
    [networkSelectPlaceholder]: 'Select Network',
    [subnetSelectLabel]: 'Subnet',
    [subnetDropdownPlaceholder]: 'Select Subnet',
    [subnetInputPlaceholder]: 'Enter Subnet',
};
